import styled from "styled-components";
import { BaseModalContainer } from "../modals.styled";

export const ModalContainer = styled(BaseModalContainer)`
    width: 80vw;

    @media (max-width: 768px) {
        height: 70vh;
        width: 95vw;
    }
`;

export const MenuAndTableContainer = styled.div<{ readOnlyMode: boolean }>`
    background: ${(props) => props.theme.colors.neutral[150]};
    display: flex;
    flex-flow: column;
    overflow: hidden;

    & > * {
        &:first-child {
            flex: 0 0 2.3rem;
            min-width: 2.3rem;
        }
        &:nth-child(2) {
            flex: 1;
        }
        &:nth-child(3) {
            min-width: 2.3rem;
            flex: 0 0 2.3rem;
            margin: 0.6rem;
        }
    }
`;

export const TableScrollWrapper = styled.div`
    overflow: auto;
`;

export const StyledTable = styled.div`
    width: min-content;
    padding: 0.6rem;
`;

export const RowsContainer = styled.div`
    display: flex;
    flex-flow: column;
`;
